import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"url(#a)\" d=\"M12.01 2a7.46 7.46 0 0 0-7.45 7.45c0 4.89 6.18 11.81 6.44 12.1a1.36 1.36 0 0 0 2 0c.66-.73 6.44-7.32 6.44-12.1A7.46 7.46 0 0 0 12.01 2m0 18.43c-.81-.94-5.95-7-5.95-11a6 6 0 0 1 11.9 0c0 3.4-3.83 8.6-5.95 11\"></path><path fill=\"#4EBC73\" d=\"M12.01 20.43c2.12-2.4 6-7.6 6-11a5.95 5.95 0 1 0-11.9 0c-.05 4.02 5.08 10.06 5.9 11m0-14.1a3.12 3.12 0 1 1 0 6.24 3.12 3.12 0 0 1 0-6.24\"></path><defs><linearGradient id=\"a\" x1=\"4.56\" x2=\"19.46\" y1=\"12\" y2=\"12\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#4EBC73\" stop-opacity=\".3\"></stop><stop offset=\"1\" stop-color=\"#4EBC73\"></stop></linearGradient></defs>", 3)
  ])))
}
export default { render: render }